module.exports = {
  BUILD_NUMBER: '2026-11-04',
  PROJECT_VERSION: "hsckEMR.0.76",
};
